import defaultClient from '@src/api/clients/default';

const URL = (path) => `dashboard/channel-summary/${path}/`;

export function fetchChannelSummaryByDate(payload = {}) {
  return defaultClient.request({
    url: URL('channel-date'),
    payload,
  });
}

export default {
  fetchChannelSummaryByDate,
};
